import { render } from "./VehicleTag.vue?vue&type=template&id=1fb246d1"
import script from "./VehicleTag.vue?vue&type=script&lang=js"
export * from "./VehicleTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/VehicleTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fb246d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fb246d1', __exports__)) {
    api.reload('1fb246d1', __exports__)
  }
  
  module.hot.accept("./VehicleTag.vue?vue&type=template&id=1fb246d1", () => {
    api.rerender('1fb246d1', render)
  })

}


export default __exports__